import React from "react"

export const BackArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      x="0"
      y="0"
      fill="#FFF"
      viewBox="0 0 512 512"
    >
      <path d="M250.343 357.657L148.687 256 250.343 154.343 261.657 165.657 171.313 256 261.657 346.343z"></path>
      <path d="M346.343 357.657L244.687 256 346.343 154.343 357.657 165.657 267.313 256 357.657 346.343z"></path>
    </svg>
  )
}

export const PlayIcon = ({ play, white = false}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      x="0"
      y="0"
      fill={play ? "#39ff14" : white ? '#fff' : "#1A1A1A"}
      enableBackground="new 0 0 100 100"
      viewBox="0 0 100 100"
    >
      <path d="M50 4.5C24.9 4.5 4.5 24.9 4.5 50S24.9 95.5 50 95.5 95.5 75.1 95.5 50 75.1 4.5 50 4.5zm0 86C27.7 90.5 9.5 72.3 9.5 50S27.7 9.5 50 9.5 90.5 27.7 90.5 50 72.3 90.5 50 90.5z"></path>
      <path d="M67.8 48.3L41.6 33.2c-.6-.4-1.4-.4-2 0-.6.4-1 1-1 1.7v30.2c0 .7.4 1.4 1 1.7.3.2.7.3 1 .3s.7-.1 1-.3l26.2-15.1c.6-.4 1-1 1-1.7s-.4-1.4-1-1.7z"></path>
    </svg>
  );
}
